"use client"

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"

import { cn } from "@/lib/utils"

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "cy:flex cy:items-center cy:gap-2 cy:text-sm cy:leading-none cy:font-medium cy:select-none cy:group-data-[disabled=true]:pointer-events-none cy:group-data-[disabled=true]:opacity-50 cy:peer-disabled:cursor-not-allowed cy:peer-disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Label }
